import { CurrencyCodeObject } from './CurrencyCodeObject';
import { Dictionary } from './Dictionary';

/**
 * model of currency setting, used for piping in component templates
 */
export interface CurrencyContext {
  code: string;
  map: Dictionary<CurrencyCodeObject>;
}
